<template>
  <div style="overflow: hidden;">
    <LineChart
      key="distance-chart"
      v-if="currentMetric === SESSION_METRICS.WORKLOAD"
      :data="data" 
      :duration="activityInfo.durationInSeconds"
      :height="500"
      :x="{ min: 0, max: activityInfo.durationInSeconds }"
      :y="{ min: 0, max: yValues.maxValue }"
      :x-unit="'min'"
      :y-unit="'m'"
      :y-axis-title="$t('CALENDAR_ACTIVITY.activityCharts.activityDistanceChart.vAxisTitle')"
      :x-axis-titlte="$t('CALENDAR_ACTIVITY.activityCharts.activityDistanceChart.xAxisTitle')"
      :y-ticks="yValues.ticks"
      :x-max-seconds="activityInfo.durationInSeconds"
      :display-brushes="activityInfo.activityType === sessionTypes.INDIVIDUAL && activityInfo.status === 'PROCESSED'"
      :on-brush-creation="onBrushCreation"
      :segments="segments"
      :activity-status="activityInfo.status"
      :player-info="activityInfo"
      :main-line-color="'#F68D2E'"
      :zoomSelection="zoomSelection"
      :updateZoomSelection="onUpdateSelection"
    />

    <div class="switch-control-row fa-pull-right" v-show="currentMetric === SESSION_METRICS.DISTANCE">
      <div class="row-content">
        <div class="row-content-item">
          <div class="btn-group calendar-view-filter switch-btn-group switch-btn-group-orange" @click="switchDistanceChartUnitAndLog">
            <label class="btn" 
              :class="{'active': distanceChartUnit == distanceUnits.PERCENTAGE}">%</label>
            <label class="btn" 
              :class="{'active': distanceChartUnit == distanceUnits.METERS}">m</label>
          </div>
        </div>
      </div>
    </div>

    <button 
      v-if="currentMetric === SESSION_METRICS.WORKLOAD" 
      class="btn btn-type-2 no-outline download-image uppercase" 
      @click="buildImageUrlAndLog" >{{ $t('CALENDAR_ACTIVITY.activityCharts.saveChartAsImage')}}</button>

    <HorizontalTimelineChart 
      v-if="currentMetric === SESSION_METRICS.DISTANCE"
      :data="data"
      :maxValue="maxValue"
      :ticks="ticks"
      :tickUnit="tickUnit"
      :data-unit="dataUnit"
      :percentage="percentage"
      :max-percentage-value="maxPercentageValue"
      :chart-axis-label="chartAxisLabel" />
  </div>
</template>

<script>
import LineChart from '@/components/common/chart/LineChart';
import HorizontalTimelineChart from '@/components/common/chart/horizontal-timeline-chart/HorizontalTimelineChart';
import { SESSION_TYPES, SESSION_METRICS, DISTANCE_ZONES_UNITS } from '@/constants/SessionConsts';

export default {
  name: 'ActivityDistanceChart',
  props: [
    'data',
    'maxValue',
    'ticks',
    'tickUnit',
    'dataUnit',
    'percentage',
    'maxPercentageValue',
    'chartAxisLabel',
    'brushCreatingTriggered',
    'onUpdateSelection',
    'activityInfo',
    'segments',
    'zoomSelection',
    'currentMetric',
    'distanceChartUnit',
    'changeDistanceChartUnit',
    'buildImageUrlAndLog'
  ],
  data () {
    return {
      sessionTypes: SESSION_TYPES,
      SESSION_METRICS: SESSION_METRICS,
      distanceUnits: DISTANCE_ZONES_UNITS
    }
  },
  computed: {
    yValues () {
      let highestValue = 0;
      const defaultYTicks = [0, 25, 50, 75, 100, 125, 150, 175, 200, 225];

      for(let i = 0; i < this.data.length; i++) {
        const player = this.data[i];

        for(let j = 0; j < player.dataPoints.length; j++) {
          if(player.dataPoints[j] > highestValue) {
            highestValue = player.dataPoints[j];
          }
        }
      }

      if(highestValue <= defaultYTicks[defaultYTicks.length - 1]) {
        return { ticks: defaultYTicks, maxValue: defaultYTicks[defaultYTicks.length - 1] };
      }

      while(highestValue > defaultYTicks[defaultYTicks.length - 1]) {
        defaultYTicks.push(defaultYTicks[defaultYTicks.length - 1] + 25);
      }

      return { ticks: defaultYTicks, maxValue: defaultYTicks[defaultYTicks.length - 1] };
    }
  },
  methods: {
    onBrushCreation ({ selection }) {
      this.brushCreatingTriggered(selection)
    },
    switchDistanceChartUnitAndLog () {
      const newUnit = this.distanceChartUnit === this.distanceUnits.PERCENTAGE ? this.distanceUnits.METERS : this.distanceUnits.PERCENTAGE
      this.changeDistanceChartUnit(newUnit)
      this.$amplitude.logEvent('pwa: change activity distance chart unit', {unit: newUnit})
    }
  },
  components: {
    HorizontalTimelineChart,
    LineChart
  }
}
</script>

<style lang="scss">
  .download-image {
    font-size: 15px;
    text-transform: uppercase;
  }
</style>
